import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logoutUser } from "../../model/profile/actions";
import { Spinner } from "react-bootstrap";

class AccountLogin extends Component {

  componentDidMount() {
    this.props.logoutUser();
  }

  render() {
    return (
      <>
      {
        this.props.profile.profileId !== undefined &&
        <div>
          <Spinner animation={"border"}/>
        </div>
      }
      {
        this.props.profile.profileId === undefined &&
        <div>
          <p>Logged out!</p>
          <Link to="/login" className="small">Login Here!</Link>
        </div>
      }
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default withRouter(connect(mapStateToProps, { logoutUser })(AccountLogin))
